import { AppSettings } from '../app.settings';
import { InboundScreenFiltersDataModel } from './inbound-screen-filters-data-model';

export class InboundScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  filterData: InboundScreenFiltersDataModel = new InboundScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    filterData: InboundScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.filterData = options.filterData;
    }
  }
};
